// Import style
import './style.scss';

// Import dependencies
import isDefined from '@automator/utilities/is-defined';

/**
 * Shows an element using the fade in effect
 *
 * @param {Node}     $element The element to fade
 * @param {Callback} callback The function invoked once the fade is completed
 * @return {undefined}
 */
const fadeIn = ( $element, callback ) => {
	// Hide the element
	$element.style.display = 'none';

	// Set opacity to 0
	$element.style.opacity = '0';

	setTimeout( () => {
		// Add the class
		$element.classList.add( 'uap-fade-in' );

		// Show the element
		$element.style.display = 'block';

		setTimeout( () => {
			// Set the opacity to 1
			$element.style.opacity = '1';

			// Wait for the animation to end
			setTimeout( () => {
				// Remove the class
				$element.classList.remove( 'uap-fade-in' );

				// Invoke the callback
				if ( isDefined( callback ) ) {
					callback();
				}
			}, 150 );
		}, 0 );
	}, 0 );
};

export default fadeIn;

window.fadeIn = fadeIn;
